<app-header *ngIf="!isPrinting && isLoggedIn()"></app-header>
<router-outlet></router-outlet>
